import { Row, Col } from 'reactstrap';
import { useState } from 'react';
import PaginatedTableStock from '../../components/reportes/stock/PaginatedTableStock';
import { PageTitle } from '../../components/common';

const Stock = () => {  
    
    // Para guardar la tabla de Lotes.
    const [tableData, setTable] = useState([]);
    const [nro_cliente, setNroCliente] = useState("all");
    
    return (
      <div style={{ padding: '0' }}>
        <PageTitle>Stock</PageTitle>
        <Row className='my-4'>
          <Col xs="12" md="12" lg="12">   
            <PaginatedTableStock
              itemsPerPage={10}
              csvName={"reporte_stock.xlsx"}
              getTableData={setTable}
              getNroCliente={setNroCliente}>
            </PaginatedTableStock>  
          </Col>
        </Row>
      </div>
    );
};

export default Stock;